<template>
  <div class="top">
    <div class="top-button is-left">
      <img class="icon-collapse" :src="require(`@/assets/img/navbar/menu-${isCollapse ? 'open' : 'collapse'}.png`)" @click="collapseMenu"/>
      <div class="super-navs">
        <div class="super-nav" :class="{ 'is-active': item.id === opened }" v-for="(item,index) in permissionAddRoutes" :key="item.id" @click="openMenu(item.id,index)">
          <p>{{ $t(item.label) }}</p>
        </div>
      </div>
    </div>
    <div class="top-button is-right">
      <!--<div style="margin-right: 100px;">{{$t('demo.msg')}}</div>-->
      <div style="margin-right: 20px;">
        <el-link type="primary" @click="showHelp" style="margin-bottom: 5px;">{{$t('homepage.txt032')}}</el-link><!-- 操作指引 -->
      </div>
      <div style="margin-right: 20px;"><ChangeLanguage  @reload="changeLanguage"/></div>
      <div class="select">
        <el-select
          ref="customer"
          class="company"
          v-model="customer"
          filterable
          remote
          value-key="custid"
          placeholder="请选择客户"
          :remote-method="getUserCusList"
          :loading="loadingUser"
          @change="changeUser"
          default-first-option
        >
          <el-option
            v-for="item in customers"
            :key="item.custid"
            :label="item.custname"
            :value="item"
          />
        </el-select>
      </div>
      <span class="ciic-cursor-pointer pifu marginRight10">
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-yonghu1" />
        </svg>
      </span>
      <el-dropdown>
        <span class="ciic-cursor-pointer">
          <span>{{ currentUser }}</span>
          {{ userInfo.mobile }}
          <svg
            class="icon xiala"
            aria-hidden="true"
          >
            <use xlink:href="#icon-xiala" />
          </svg>
        </span>
        <el-dropdown-menu slot="dropdown">
                    <!--<el-dropdown-item>-->
                      <!--<span @click="handleUserClick">基本信息设置</span>-->
                    <!--</el-dropdown-item>-->
<!--          <el-dropdown-item>-->
<!--            <span @click="openIframeDialog('修改密码','/jsp/modifyPassword.jsp')">修改密码</span>-->
<!--          </el-dropdown-item>-->
          <el-dropdown-item>
            <span @click="openUpdate()">{{$t('index.txt001')}}</span> <!--修改密码-->
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            {{$t('index.txt002')}}<!--退出登录-->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--iframe弹框-->
    <el-dialog
      custom-class="iframeBox"
      :title="iframeTitle"
      :visible.sync="iframeDialog"
      :close-on-click-modal="false"
      width="80%"
      top="2vh"
    >
      <div style="height: calc(100vh - 150px)">
        <pubIndex
          :fpath="routerPath"
          v-if="iframeDialog"
        />
      </div>
    </el-dialog>

    <user-help ref="userHelp" class="userHelp" @reload="userHelpClose"></user-help>

  </div>

</template>
<script>
  import { mapGetters } from "vuex";
  import { fullscreenToggel, listenfullscreen } from "@/util/util";
  import { validatenull } from "@/util/validate";
  import { queryUserListPage, updateBatchMsgStatus } from "@/api/msg/msg";
  import { getUserCusList, switchUser, getSysApi } from "@/api/sys/cus";
  import { queryUserHelpStatus, createUserHelpStatus } from "@/api/home/home";
  import cross from "@/util/cross";
  import pubIndex from "@/views/pub/pubIndex";
  import homeMenus from '@/menus/home/home';
  import ChangeLanguage from './change-language'
  import UserHelp from './user-help'
  import {getCloudDeptByPerId} from "@/api/cost/cost";
  export default {
    inject: ['reload'],
    name: "Top",
    components:{
      UserHelp,
      pubIndex,
      ChangeLanguage
    },
    data() {
      return {
        dark: false,
        dialogFormMyservice: false,
        home: false, //工作台
        search: "",
        currentUser: "",
        disableds:false,
        msgList: [],
        gongsiPage:{
          a:[],
          b:"",
        },
        updateStatus: {
          ids: [],
          status: 23
        },
        msgPage: {
          limit: 50,
          page: 1,
          total: 0,
          status: 22
        },
        customers:[],
        customer : {},
        loadingUser: false,
        month: '',
        iframeDialog:false,//显示iframe弹框
        iframeUrl: "",
        iframeTitle: "",
        routerPath: '',
        isInit: true,
        firstFlag: false,
      };
    },
    filters: {},
    watch: {
      // 凭证复核页面，因不同的业务员关联不同的客户，需要重新设置客户列表，并且设置第一个客户为默认客户
      // isNeedChangeUser() {
      //   this.getUserCusList('');
      // },
      customer(val,oldVal) {
        if (!this.isInit) {
          let that = this;
          this.$alert(this.$t("homepage.txt021") + `${val.custname}！`, this.$t("homepage.txt017"), {//客户已切换为   提示
            confirmButtonText: this.$t("homepage.txt018"), //确认
            type: 'warning'
          }).then(() => {
            that.$emit('isMask',true)
            this.switchUser(1, val, this.month, function() {
              that.openMenu(that.permissionAddRoutes[0].id, 0);
              that.$emit('isMask',false)
              // that.$router.push({ path: "/index" });
            });
          }).catch(() => {
            this.isInit = true;
            this.customer = oldVal;
            if (!!this.$refs.customer) {
              this.$refs.customer.blur();
            }
          });
        }
      },
      month(val, oldVal) {
       if (!this.isInit) {
         let that = this;
         this.$alert(this.$t("homepage.txt020")+val+"!", this.$t("homepage.txt017"), { //日期已切换为   提示
           confirmButtonText: this.$t("homepage.txt018"), //确认
           type: 'warning',

         }).then(() => {
           that.$emit('isMask',true)
           this.disableds=true
           this.switchUser(2, this.customer, val,function(){
             that.$emit('isMask',false)
           });
         }).catch(() => {
           this.month = oldVal;
           this.isInit = true;
           this.$refs.month.blur();
         });
       }
      }
    },
    created() {
      this.currentUser = this.userInfo.name;
      // 设置日期
      this.initTop();
      this.disableds=true
      // 初始化客户列表
      this.initUserCusList();
      this.queryUserHelpStatus();
    },
    mounted() {
      let that = this;
      this.dark = localStorage.Theme != "light-theme";
      this.$nextTick(function() {
        let opened = this.opened;
        if (validatenull(opened)) {
          this.openMenu(that.permissionAddRoutes[0].id);
          // this.showCollapse();
        } else {
          this.openMenu(opened);
        }
        this.$store.commit('SET_COLLAPSE','open');
      });
      // 其他页面调用本页面的方法
      cross.$on("resHomeMsg", function(msg) {
        that.queryMsg();
      });
    },
    computed: {
      ...mapGetters(["isFullScren", "isCollapse", "userInfo", "opened", "memberInfo", "themeType", "accessToken", "permissionAddRoutes"])
    },
    methods: {
      queryUserHelpStatus(personId) {
        let params = {};

        queryUserHelpStatus(params)
          .then((response) => {
            let result = response.data;
            console.log("queryUserHelpStatus", result)
            if(result.code == '0' && result.data == "00900"){
              this.firstFlag = true;
              this.showHelp();
            }
          })
          .catch(error => {
            console.log("error", error)
          });

      },
      createUserHelpStatus(personId) {
        let params = {};

        createUserHelpStatus(params)
          .then((response) => {
            let result = response.data;
            console.log("queryUserHelpStatus", result)
          })
          .catch(error => {
            console.log("error", error)
          });

      },
      collapseMenu(){
        this.$store.commit("SET_COLLAPSE");
      },
      openUpdate() {
        this.$emit('openUpdatePwd'); // 触发自定义事件
      },
      // 设置默认日期
      initTop() {
        const curDate = new Date();
        let year = curDate.getFullYear();
        let month = curDate.getMonth() + 1;
        this.month = this.userInfo.month || year + '-' + (month < 10 ? '0' + month : month);
      },
      openIframeDialog(title,url){
        this.iframeDialog = true;
        this.iframeTitle = title;
        this.routerPath = url;
      },
      // 设置消息为已读
      alreadyRead(id) {
        this.updateStatus.ids.push(id);
        updateBatchMsgStatus(this.updateStatus).then(res => {
          if (res.data.data) {
            let inx = this.msgList.findIndex((item) => {
              return item.id = id;
            });
            this.msgPage.total--;
            this.msgList.splice(inx, 1);
            this.$message.success("标记已读成功");
          } else {
            this.$message.error("标记已读失败");
          }
        });

      },
      initWebSocket() {
        this.connection();
      },
      //上线
      connection() {
        let baseUrl = process.env.VUE_APP_BASE_URL;
        //建立连接对象
        let socket = new SockJS(baseUrl + "/message/ws");
        // 获取STOMP子协议的客户端对象
        this.stompClient = Stomp.over(socket);
        //将socket对象存在session里
        // sessionStorage.setItem("stompClient", this.stompClient);
        this.stompClient.debug = null;
        // 定义客户端的认证信息,按需求配置
        let headers = {
          "Authorization": "Bearer " + this.accessToken
        };
        // 现在用用户id去获取消息后期要改成成员id

        let userId = this.memberInfo.id;
        // 向服务器发起websocket连接
        this.stompClient.connect(headers, () => {
          this.stompClient.subscribe("/user/" + userId + "/message", (msg) => {
            //把实时收到的消息放入消息提醒列表中
            let msgObj = {};
            msgObj.content = msg.body;
            msgObj.templateId = msg.body.substring(0, 1);;
            msgObj.status = 22;
            this.msgList.push(msgObj);
            this.$set(this.msgList, msgObj);
            this.msgPage.total = this.msgPage.total + 1;
            this.resetSetItem("sockedMsgContent", msg.body);
          }, headers);
        }, (err) => {
          // 连接发生错误时的处理函数
          console.log("失败");
          console.log(err);
        });
      },
      openMenu(id){
        this.$store.commit('SET_COLLAPSE','open');
        this.$store.commit('SET_OPENED',id);
        this.home = false;
        const findModule = this.permissionAddRoutes.find(item => item.id == id)
        if (findModule) {
          const showMenus = findModule.children;
          this.$store.commit('SET_MENU', [...homeMenus, ...showMenus]);
        }
      },
      //查询消息
      queryMsg() {
        queryUserListPage(this.msgPage).then(res => {
          this.msgList = res.data.records;
          this.msgPage.total = res.data.total;
        });
      },
      msgContent(content, msg, templateId) {
        return msg;  //todo  返回之前的数据
        let arr = content.trim().split(/\s+/);
        let subString = content.slice(content.indexOf(" ") + 1);
        if (content && content != "null") {
          let obj = {};
          obj.templateId = JSON.parse(arr[0]);
          obj.content = JSON.parse(subString);
          content.indexOf();
          let t = content.split(templateId);
          return JSON.parse(subString);
        }
      },
      getCurrentLoginUser() {
        let memberId = this.memberInfo.id;
      },
      showCollapse() {
        this.home = true;
        this.$store.commit('SET_COLLAPSE','close');
        this.$router.push({ path: '/index' });
        this.$store.commit('SET_OPENED', '1');
      },
      handleScreen() {
        fullscreenToggel();
      },
      huanfu() {
        if (localStorage.getItem("Theme") == "light-theme") {
          localStorage.setItem("Theme", "dark-theme");
          localStorage.setItem("Color", "#ffffff");
          this.$store.commit("CHANGECOLOR");
          this.dark = true;
          document.getElementsByTagName("body")[0].className = localStorage.getItem("Theme");

        } else {
          localStorage.setItem("Theme", "light-theme");
          localStorage.setItem("Color", "#000000");
          this.$store.commit("CHANGECOLOR");
          this.dark = false;
          document.getElementsByTagName("body")[0].className = localStorage.getItem("Theme");
        }
      },
      setScreen() {
        this.$store.commit("SET_FULLSCREN");
      },
      tohelp() {
        this.$router.push({ path: "/help" });
      },
      logout() {
        this.$confirm(this.$t("homepage.txt016"), this.$t("homepage.txt017"), {  // 将要退出系统, 是否继续？   提示
          confirmButtonText: this.$t("homepage.txt018"), //确认
          cancelButtonText: this.$t("homepage.txt019"), //取消
          type: "warning"
        }).then(() => {
          //todo注释退出方法 ,直接跳转
          //this.$router.push({ path: "/login" });
          this.$store.dispatch("LogOut").then(() => {
            // 清除记录的tab  name
            if (sessionStorage.getItem("tabIndex")) {
              sessionStorage.removeItem("tabIndex");
            }
            this.$router.push({ path: "/login" });
            this.$store.commit("SET_OPENED", '1');
          }).catch(function (err) {
            //捕获异常
            this.$store.commit("SET_OPENED", '1');
            this.showCollapse();
          });;

        }).catch(() => {});
      },
      /**
       * 处理设置的点击事件
       * @param item
       */
      handleSettingClick(item) {
        // 清除记录的tab  name
        if (sessionStorage.getItem("tabIndex")) {
          sessionStorage.removeItem("tabIndex");
        }

        if (item.path) {
          if (item.path === this.$route.path) {
            this.reload();
          } else {
            let path = item.path;
            let params = "";
            // 处理路由URL带参数的菜单
            if (typeof item.params === "function") {
              params = item.params(this.$store);
              if (item.path && item.path.indexOf("/:") !== -1) {
                const pathItemArr = item.path.split("/");
                pathItemArr.forEach((pathItem) => {
                  if (pathItem.indexOf(":") === 0) {
                    const paramName = pathItem.substring(1);
                    path = path.replace(pathItem, params[paramName]);
                  }
                });
              }
            }
            this.$router.push({
              path: path,
              query: item.query
            });
          }
        } else {
          item.handle(this);
        }
      },
      /**
       * 处理用户信息的点击事件
       * @param item
       */
      handleUserClick() {
        // 清除记录的tab  name
        if (sessionStorage.getItem("tabIndex")) {
          sessionStorage.removeItem("tabIndex");
        }
        this.$router.push("/person/edit");
      },
      changeLanguage(){

      },
      toMsg() {
        // 清除记录的tab  name
        if (sessionStorage.getItem("tabIndex")) {
          sessionStorage.removeItem("tabIndex");
        }
        this.$router.push("/cus/msgTabs");
      },
      // 初始化客户（公司）列表
      initUserCusList() {
        this.loadingUser = true;
        const params = {
          name: '',
        }
        let that = this;
        getUserCusList(params)
          .then(response => {
            that.loadingUser = false;
            this.disableds=false
            if (response.data.data.length && response.data.data.length > 0) {
              that.customers = response.data.data;
              let res = that.customers.find(val => {
                return val.custid == that.userInfo.cusId;
              });
              that.customer = res || that.customers[0];
              if (!res) {
                that.switchUser(1, that.customer, that.month);
              }
            } else {
              that.$alert(`用户无操作权限！`, '提示', {
                confirmButtonText: '确定',
                type: 'warning'
              }).then(() => {
                that.$router.go(-1);
              });
            }
          })
          .catch(error => {
            that.loadingUser = false
          });
      },
      // 获取客户（公司）列表
      getUserCusList(query) {
        this.loadingUser = true;
        const params = {
          name: query.trim(),
        }
        getUserCusList(params)
          .then(response => {
            this.loadingUser = false;
            this.customers = response.data.data;
          })
          .catch(error => {
            this.loadingUser = false
          });
      },
      // 切换客户（公司）
      changeUser(val) {
        this.isInit = false;
      },
      changeDate(val) {
        this.isInit = false;
      },
      showHelp(){
        let params = {
          firstFlag: this.firstFlag
        }
        this.$refs.userHelp.visible = true;
        this.$refs.userHelp.optParams = params;
        this.$refs.userHelp.init();
      },
      userHelpClose(){
        this.firstFlag = false;
        this.createUserHelpStatus();
      },
      /**
       * 切换公司和日期调用接口
       * @param switchType 1-公司 2-日期
       * @param custInfo
       * @param yearMonth
       */
      switchUser(switchType, custInfo, yearMonth, func) {
        let params = {
          custId: custInfo.custid,
          custName: custInfo.custname
        }
        this.$refs.customer.blur();
        let that = this;
        let actionName = switchType == 1 ? '/pms/switchUser.action' : '/pms/switchDate.action';
        switchUser(params)
          .then(response => {
            this.disableds = switchType == 2 ? false : switchType == 1 ? false : true
            that.isInit = true;
            const data = response.data.data;
            const userInfo = {
              ...data,
              cusId: params.custId,
              cusName: params.custName,
            };
            that.$store.commit('SET_ACCESS_TOKEN', response.data.data.accessToken);
            that.$store.commit('SET_PMS', data.pmsList);
            that.$store.commit('SET_USER_INFO', userInfo);
            if (func) {
              func();
              that.$store.dispatch('permission/generateRoutes', [])
              that.$store.dispatch('permission/addGenerateRoutes')
              that.openMenu('1')
              that.reload()
              //todo shipengchao 这里尝试一下局部刷新
              //this.$router.replace('/index')
              location.reload()
            }
            return;

            //调用老业务系统认证 注释掉：暂不从前端发起调用
            const paramsSys = {
              id: custInfo.custid,
              name: custInfo.custname
            }
            getSysApi(actionName, paramsSys)
              .then(res => {
                this.$store.commit('SET_USER_INFO', userInfo);
                window.location.reload();
              })
              .catch(error => {
              })
          })
          .catch(error => {
          })
      }
    }
  };
</script>
<style lang="scss" scoped>
  .icon-collapse {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin-left: 20px;
  }
  span + .xiala {
    margin-left: 0;
    font-size: 12px;
  }
  .pifu {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .pifu .icon {
    font-size: 18px;
    margin: 0;
  }
  .super-navs {
    padding-left: 20px;
    display: flex;
    cursor: pointer;
    height: 100%;
    .super-nav {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #999999;
      padding: 7px 5px;
      position: relative;
      margin-right: 15px;
      &:hover {
        color: #C73122;
      }
      &.is-active {
        color: #C73122;
        &::before{
          content:"";
          width: 100%;
          height: 3px;
          border-radius: 2px;
          background: #C73122;
          position: absolute;
          bottom:0;
          left:0;
        }
      }
      p {
        font-size: 14px;
        line-height: 46px;
        font-weight: bold;
      }
      .icon {
        margin: 0;
      }
    }
  }
  .top {
    padding-left: 0;
  }
  .icon {
    font-size: 30px;
    margin-top: 2px;
    margin-right: 6px;
  }
  .company{
    margin-right: 20px;
    width: 240px;
    background: #F5F5F5;
    border-radius: 4px;
    color:#999999;
  }
  .top ::v-deep  .el-input__inner{
    border:none!important;
  }
  .top-button{
    height: 100%;
  }
  .is-right ::v-deep .iframeBox .el-dialog__body{
    padding: 0;
  }
</style>

